export default __webpack_public_path__ + "static/media/Illusionist's Longsword.f5ea4055.jpg";